import { FormControlBase } from '../models/form-control-base';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlSignature extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Signature;
}
